<script>
import {mapActions} from "vuex";
import InfiniteAfterDisposalItemCategoryAutoComplete
  from "@/driver/components/InfiniteAfterDisposalItemCategoryAutoComplete.vue";
import InfiniteAfterDisposalItemSubcategoryAutoComplete
  from "@/driver/components/InfiniteAfterDisposalItemSubcategoryAutoComplete.vue";

export default {
  name: "RecycleDisposedItemModal",
  components: {
    InfiniteAfterDisposalItemSubcategoryAutoComplete,
    InfiniteAfterDisposalItemCategoryAutoComplete
  },
  props: {
    enableDialog: {
      type: Boolean,
      default: false,
    },
    targetId: {
      type: Number,
      default: null,
    },
    duplicate: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    afterType: {
      type: String,
      default: "after_industrial"
    }
  },
  data() {
    return {
      form: null
    }
  },
  computed: {
    isEdit () {
      return !!this.targetId
    },
  },
  watch: {
    enableDialog (newValue) {
      this.form = null;
      if (newValue) {
        this.$nextTick(() => this.$refs.recycleDisposedItemFormValidation.reset())
        this.initializeDialog()
      }
    },
  },
  created() {},
  methods: {
    // Vuex アクションのマッピング（処理後物マスタ CRUD）
    ...mapActions('DriverMasterRecycleDisposedItem', {
      newRecycleDisposedItem: 'new',
      editRecycleDisposedItem: 'edit',
      createRecycleDisposedItem: 'create',
      updateRecycleDisposedItem: 'update',
    }),

    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.recycleDisposedItemFormValidation.validate().then((result) => {
        if (result) {
          this.sendRegistrationInformation()
        }
      })
    },

    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      console.log('closeButtonClickEvent')
      this.$emit('close')
    },

    initializeDialog () {
      this.editRecycleDisposedItem({ id: this.targetId }).then((content) => {
        this.form = content
        if (this.duplicate) {
          this.form.id = null;
          this.form.use_subclass = true;
        }
      })
    },

    /**
     * 処分後物の種別 チェンジイベント
     */
    afterTypeChangeEvent () {
      this.form.after_disposal_item_major_name = null;
      this.form.after_disposal_item_id = null;
      this.form.after_disposal_item_code = null;
      this.form.code = null;
    },

    /**
     * 処理後物の大分類 コールバック
     * @param object
     */
    categoryChangedCallback (object) {
      if (!object) {
        this.form.after_disposal_item_major_name = null;
        this.form.after_disposal_item_id = null;
        this.form.after_disposal_item_code = null
        this.form.after_disposal_item_name = null;
        this.form.code = null;
        this.searchButtonClickEvent();
        return;
      }
      this.form.after_disposal_item_major_name = object.text;
    },

    /**
     * 処理後物の種類 コールバック
     * @param object
     */
    subcategoryChangedCallback (object) {
      if (!object) {
        this.form.after_disposal_item_id = null;
        this.form.after_disposal_item_code = null;
        this.form.after_disposal_item_name = null;
        this.form.code = null;
        return;
      }
      this.form.after_disposal_item_major_name = object.category_name;
      this.form.after_disposal_item_id = object.value;
      this.form.after_disposal_item_code = object.code;
      this.form.after_disposal_item_name = object.text;
      this.form.code = object.code;
      this.subClassCodeChange();
    },

    /**
     * 細分類を設定 クリックイベント
     */
    useSubClassClick () {
      if (!this.form.use_subclass) {
        this.form.code = this.form.after_disposal_item_code;
        return;
      }
      this.subClassCodeChange();
    },

    /**
     * 細分類コード チェンジイベント
     */
    subClassCodeChange () {
      // 処理後物の種類が選択されていない場合は処理しない
      if (!this.form.after_disposal_item_code) return;

      // 細分類コードが3桁でない場合はオリジナルコードをセットする.
      if (this.form.subclass_code.length !== 3) {
        this.form.code = this.form.after_disposal_item_code;
        return;
      }
      this.form.code = this.form.code.slice(0, 7) + this.form.subclass_code;
    },

    /**
     * 送信パラメータの生成
     */
    buildParam () {
      return {
        code: this.form.code,
        after_type: this.form.after_type,
        after_disposal_item_id: this.form.after_disposal_item_id,
        use_subclass: this.form.use_subclass,
        subclass_code: this.form.subclass_code,
        subclass_name: this.form.subclass_name,
        sort_priority: this.form.sort_priority,
        invisible: this.form.invisible,
      };
    },

    /**
     * 送信処理
     */
    sendRegistrationInformation () {
      const params = this.buildParam();
      if (this.duplicate) {
        this.createRecycleDisposedItem({ params: params }).then(() => {
          this.$emit('register')
        })
      } else {
        this.updateRecycleDisposedItem({ id: this.targetId, params: params }).then(() => {
          this.$emit('register')
        })

      }
    },

  },
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    max-width="720"
    persistent
    scrollable
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>処理後物{{ isEdit ? '編集' : '追加' }}</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text
        v-if="form"
        class="pt-2"
        style="overflow-y: auto"
      >
        <validation-observer ref="recycleDisposedItemFormValidation">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="form.code"
                dense
                filled
                hide-details="auto"
                label="コード"
                outlined
                persistent-placeholder
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-checkbox
                v-model="form.invisible"
                class="float-end"
                dense
                hide-details="auto"
                label="非表示にする"
              />
            </v-col>
          </v-row>

          <h2 class="primary--text font-weight-medium ml-2 mt-3 mb-2">処理後物分類</h2>

          <v-row>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                name="種別"
                rules="required"
              >
                <v-radio-group
                  v-model="form.after_type"
                  :disabled="isEdit"
                  :error-messages="errors"
                  hide-details="auto"
                  row
                  @change="afterTypeChangeEvent"
                >
                  <v-radio
                    value="after_industrial"
                    label="廃棄物"
                  />
                  <v-radio
                    value="after_recycling"
                    label="再資源"
                  />
                </v-radio-group>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <infinite-after-disposal-item-category-auto-complete
                :category-name="form.after_disposal_item_major_name"
                :after-type="afterType"
                :disabled="isEdit"
                label="処理後物の大分類"
                required
                @update:values="categoryChangedCallback"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <infinite-after-disposal-item-subcategory-auto-complete
                :subcategory-id="form.after_disposal_item_id"
                :category-name="form.after_disposal_item_major_name"
                :after-type="afterType"
                :disabled="isEdit"
                label="処理後物の種類"
                required
                @update:values="subcategoryChangedCallback"
              />
            </v-col>
          </v-row>

          <h2 class="primary--text font-weight-medium ml-2 mt-3 mb-2">細分類</h2>

          <v-row>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="form.use_subclass"
                disabled
                dense
                hide-details="auto"
                label="細分類を設定"
                @click="useSubClassClick"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, numeric: true, length: 3 }"
                :class="{ requiredMark: form.use_subclass }"
                :disabled="!form.use_subclass"
                name="細分類コード"
              >
                <v-text-field
                  v-model="form.subclass_code"
                  :disabled="!form.use_subclass"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  clearable
                  hint="半角数字3桁"
                  label="細分類コード"
                  maxlength="3"
                  outlined
                  persistent-placeholder
                  :placeholder="form.use_subclass ? '例）001' : null"
                  @input="subClassCodeChange"
                >
                  <template v-slot:label>
                    <span>細分類コード</span>
                    <span class="ml-1">
                      ({{ form.subclass_code?.length || 0 }} / 3)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ required: true, max: 50 }"
                :class="{ requiredMark: form.use_subclass }"
                :disabled="!form.use_subclass"
                name="細分類名"
              >
                <v-text-field
                  v-model="form.subclass_name"
                  :disabled="!form.use_subclass"
                  :error-messages="errors"
                  dense
                  label="細分類名"
                  hide-details="auto"
                  clearable
                  persistent-placeholder
                  outlined
                >
                  <template v-slot:label>
                    <span>細分類名</span>
                    <span class="ml-1">
                      ({{ form.subclass_name?.length || 0 }} / 50)
                    </span>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                name="表示順"
              >
                <v-text-field
                  v-model="form.sort_priority"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="表示順"
                  outlined
                  persistent-placeholder
                  reverse
                  type="number"
                  @keydown.69.prevent
                />
              </validation-provider>
            </v-col>
          </v-row>
        </validation-observer>

      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          @click="registerButtonClickEvent"
        >
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
